import { render, staticRenderFns } from "./LoyaltyPointTransactionsTable.vue?vue&type=template&id=58a2172e&scoped=true&"
import script from "./LoyaltyPointTransactionsTable.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPointTransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPointTransactionsTable.vue?vue&type=style&index=0&id=58a2172e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2172e",
  null
  
)

export default component.exports